<h4>Select your vehicle type.</h4>
<app-vehicle-type (vehicleTypeSelected)="selectVehicleType($event)"></app-vehicle-type>
